// Vendor imports
const { connect } = require('react-redux')
// Client lib imports
const businessEvents = require('client/lib/business-events')
// Client V2 common imports
const withIsVisible = require('client-v2/common/components/is-visible')
const { navigate } = require('client-v2/common/state/router/actions')
// Entry imports
const FollowPeopleSocialAuthCard = require('./component-dumb')

function mapStateToProps(state) {
  const { providers } = state.user
  const isFacebookAvailable = !providers.has('facebook')
  const isTwitterAvailable = !providers.has('twitter')
  const isVisible = isFacebookAvailable || isTwitterAvailable
  return {
    isVisible,
    facebookHref: isFacebookAvailable ? connectHref('facebook') : null,
    twitterHref: isTwitterAvailable ? connectHref('twitter') : null
  }
}

function mapDispatchToProps(dispatch) {
  return {
    onFacebookClick: onSocialConnect('facebook'),
    onTwitterClick: onSocialConnect('twitter')
  }

  function onSocialConnect(provider) {
    return async function (event) {
      event.preventDefault() // Stop <a href> navigation
      // Wait for tracking call before navigating away from this page
      await businessEvents.trackSegment('social-connect', {
        provider
      })
      // Redirect to social-connect auth route
      dispatch(navigate({ href: connectHref(provider) }))
    }
  }
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withIsVisible(
    FollowPeopleSocialAuthCard
  )
)

function connectHref(provider) {
  return `/auth/add-follow-people-${provider}`
}
